// Kept outside App to avoid loading the application tree from tracking helpers.
export let GTM;
export const setGTM = tracker => { GTM = tracker; };
